export enum IBAN_UPDATE_WORKFLOW_PLACES  {
  UPLOAD_BANK_STATEMENT = 'upload_bank_statement',
  DOCUMENT_CHECKING = 'document_checking',
  SUMMARY = 'summary',
  CANCELED = 'canceled',
  OTP_VALIDATION = 'otp_validation',
  PROCESSING = 'processing',
  COMPLETED = 'completed'
}
